import {
    afterNextRender,
    Component,
    ElementRef,
    inject,
    Injector,
    viewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AiAgentChatMessageComponent } from './ai-agent-chat-message.component';
import { AiAgentChatStore } from './ai-agent-chat.store';

@Component({
    selector: 'na-ai-agent-chat-panel',
    providers: [AiAgentChatStore],
    imports: [
        FormsModule,
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        AiAgentChatMessageComponent,
    ],
    templateUrl: './ai-agent-chat-panel.component.html',
    styleUrl: './ai-agent-chat-panel.component.scss',
})
export class AiAgentChatPanelComponent {
    protected readonly store = inject(AiAgentChatStore);
    private readonly injector = inject(Injector);

    private readonly scrollContainer = viewChild<ElementRef<HTMLElement>>('scrollContainer');

    constructor() {
        this.store.registerOnMessageSent(() => this.scrollToBottom());
    }

    protected onSend(): void {
        this.store.sendMessageRx(this.store.inputText().trim());
    }

    protected onKeyDown(event: KeyboardEvent): void {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.onSend();
        }
    }

    protected onConfirm(actionId: string, confirmed: boolean): void {
        this.store.confirmActionRx({ actionId, confirmed });
    }

    protected onClear(): void {
        this.store.clearConversationRx();
    }

    private scrollToBottom(): void {
        afterNextRender(() => {
            const el = this.scrollContainer()?.nativeElement;
            if (el) el.scrollTop = el.scrollHeight;
        }, { injector: this.injector });
    }
}
